import { render, staticRenderFns } from "./tobExperienceCard.vue?vue&type=template&id=8bba7480&scoped=true&"
import script from "./tobExperienceCard.vue?vue&type=script&lang=js&"
export * from "./tobExperienceCard.vue?vue&type=script&lang=js&"
import style0 from "./tobExperienceCard.vue?vue&type=style&index=0&id=8bba7480&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bba7480",
  null
  
)

export default component.exports